import React, { useEffect, useState, useRef } from "react";
import ReactSelect from "react-select";
import "../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Fade from "react-reveal/Fade";
import ProgressBar from "../components/ProgressBar";
import { Titles, Gender, MaritalValue, Countries } from "../utils";
import FileUploadComponent from "../components/FIleUpload";
import Terms from "../components/terms";
import Selfie from "../components/selfie";
import PDFIcon from "../assets/pdf-svg.svg";

import { ArrowRight, Camera } from "react-bootstrap-icons";

const BasicInformation = ({ setForm, formData, navigation, loading }) => {
  const bottomRef = useRef(null);
  const topRef = useRef(null);

  const { previous, go } = navigation;

  const [accountType, setAccountType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [dob, setDOB] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [religion, setReligion] = useState("");
  const [state, setState] = useState("");
  const [lga, setLGA] = useState("");
  const [address, setAddress] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");

  const [branch, setBranch] = useState("");
  const [allBranch, setAllBranch] = useState([]);
  const [country, setCountry] = useState("");
  const [altPhone, setAltPhone] = useState("");
  const [altEmail, setAltEmail] = useState("");

  const [maritalStatus, setMaritalStatus] = useState("");
  const [bvn, setBVN] = useState("");
  const [error, setError] = useState("");
  const [validationError, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [fineInfo, setFileInfo] = useState(null);

  const [passportInfo, setPassportInfo] = useState(null);
  const [utilityInfo, setUtilityInfo] = useState(null);
  const [identityInfo, setIdentityInfo] = useState(null);
  const [signatureInfo, setSignatureInfo] = useState(null);
  const [referenceInfo, setReferenceInfo] = useState(null);

  const [fieldToUpdate, setFieldToUpdate] = useState("");
  const [passportPath, setPassportPath] = useState("");
  const [passportMimeType, setPassportMimeType] = useState("");
  const [utilityPath, setUtilityPath] = useState("");
  const [utilityMimeType, setUtilityMimeType] = useState("");
  const [identityPath, setIdentityPath] = useState("");
  const [identityMimeType, setIdentityMimeType] = useState("");
  const [signaturePath, setSignaturePath] = useState("");
  const [referencePath, setReferencePath] = useState("");
  const [signatureMimeType, setSignatureMimeType] = useState("");

  const [showTerm, setShowTerm] = useState(false);
  const [showSelfie, setShowSelfie] = useState(false);
  const [agreementCheckBox, setAgreementCheckBox] = useState(false);

  const [selfieImg, setSelfieImg] = useState(null);

  const [allDataValid, setAllDataValid] = useState(false);
  const [rmCode, setRmCode] = useState("");
  const [new_cust_id, setNewCustId] = useState("");

  const mask = (word) => {
    if (word === "" || word === undefined) {
      return "";
    } else if (word.length <= 2) {
      return word;
    } else {
      var masked =
        word.substring(0, word.length - 4) +
        word.substring(word.length - 4, word.length).replace(/[a-z\d]/gi, "*");
      return masked;
    }
  };

  function longMask(word) {
    if (word === "" || word === undefined) {
      return "";
    } else if (word.length <= 2) {
      return word;
    } else {
      var masked =
        word.substring(0, word.length - 10).replace(/[a-z\d]/gi, "*") +
        word.substring(word.length - 15, word.length);
      return masked;
    }
  }

  useEffect(() => {
    let data = JSON.parse(sessionStorage.getItem("res"));
    // console.log(data);
    // let data = verifyToken(localStorage.getItem("res"));

    const dbUserTitle = data.Gender === "Male" ? "MR" : "MRS";
    setFirstName(data.FirstName);
    setLastName(data.LastName);
    setMiddleName(data.MiddleName);
    setDOB(data.DOB);
    setPhone(data.Phone);
    setEmail(data.Email);
    setTitle(
      data.Title == undefined || data.Title == null || data.Title == ""
        ? dbUserTitle
        : data.Title
    );
    setGender(data.Gender);
    setState(data.State);
    setLGA(data.LGA);
    setAddress(data.Address);
    setMaritalStatus(data.MaritalStatus);
    setBVN(data.BVN);
    getAllBranch();
    // setFirstName(data.FirstName);
    // setLastName(data.LastName);
    // setMiddleName(data.MiddleName);
    // setDOB(data.DateOfBirth);
    // setPhone(data.PhoneNumber1);
    // setEmail(data.Email);
    // setTitle(data.Title);
    // setGender(data.Gender);
    // setState(data.StateOfOrigin);
    // setLGA(data.LgaOfOrigin);
    // setAddress(data.ResidentialAddress);
    // setMaritalStatus(data.MaritalStatus);
    // setBVN(data.BVN);

    setAltPhone(data.altPhone);
    setAltEmail(data.altEmail);
    setCountry(data.country);
    setCurrentAddress(data.address);
    setAccountType(data.acct_type);
    setReligion(data.religion);
    setBranch(data.braCode);
    setRmCode(data.rmCode);

    setPassportPath(data.passportPath);
    setPassportMimeType(data.passportMimeType);

    setUtilityPath(data.utilityPath);
    setUtilityMimeType(data.utilityMimeType);

    setIdentityPath(data.identityPath);
    setIdentityMimeType(data.identityMimeType);

    setSignaturePath(data.signaturePath);
    setReferencePath(data.referencePath);

    setSignatureMimeType(data.signatureMimeType);
    setFieldToUpdate(data.fieldToUpdate);
    setNewCustId(data.new_cust_id);
  }, []);

  // console.log(country, accountType, religion, branch);

  const canUpdateField = (str) => {
    const str_arr =
      fieldToUpdate != null && fieldToUpdate != "" && fieldToUpdate != undefined
        ? fieldToUpdate.split(",")
        : [];
    return str_arr.indexOf(str) > -1 ? true : false;
  };

  const utilityInfoStatus = utilityInfo?.status;
  const passportInfoStatus = passportInfo?.status;
  const signatureInfoStatus = signatureInfo?.status;
  const identityInfoStatus = identityInfo?.status;
  const referenceInfoStatus = referenceInfo?.status;

  // /apitest/branches
  const getAllBranch = async () => {
    try {
      const response = await axios.post(
        "https://providusonline.providusbank.com:8443/api/branches"
      );

      setAllBranch(response.data.branches);
    } catch (er) {}
  };
  useEffect(() => {
    const canContinue =
      (accountType != "" || !canUpdateField("acct_type")) &&
      (religion != "" || !canUpdateField("religion")) &&
      (country != "" || !canUpdateField("country")) &&
      (branch != "" || !canUpdateField("branch")) &&
      trimStr(currentAddress) != "" &&
      (utilityInfoStatus == "done" || !canUpdateField("utility")) &&
      (passportInfoStatus == "done" || !canUpdateField("passport")) &&
      (signatureInfoStatus == "done" || !canUpdateField("signature")) &&
      (identityInfoStatus == "done" || !canUpdateField("identity")) &&
      (referenceInfoStatus == "done" || !canUpdateField("reference")) &&
      agreementCheckBox
        ? true
        : false;
    setAllDataValid(canContinue);
  }, [
    utilityInfoStatus,
    passportInfoStatus,
    signatureInfoStatus,
    identityInfoStatus,
    referenceInfoStatus,
    accountType,
    religion,
    country,
    currentAddress,
    agreementCheckBox,
    branch,
  ]);

  const handleClose = () => {
    setShowTerm(false);
  };
  const handleCloseSelfie = () => {
    setShowSelfie(false);
  };

  const SubmitSelfie = (selfieImg) => {
    setSelfieImg(selfieImg);
  };

  // async function sendOTP(account) {
  //   const response = await axios.post(process.env.SEND_OTP, {
  //     account,
  //   });

  //   return response.data;
  // }

  const trimStr = (str) => {
    if (str != null && str != undefined) {
      return str.trim();
    }
    return "";
  };

  const ValidateEmail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }

    return false;
  };

  const onSubmit = async () => {
    // setShowTerm(false);
    // if (!action) return;
    setValidationErrors({});

    try {
      if (!title) {
        gender === "Male" ? setTitle("MR") : setTitle("MRS");
        return;
      }
      setSubmitting(true);
      loading(true);

      let tc = await Titles.filter((tt) => title.toUpperCase() === tt.title)[0]
        .code;
      let gn = await Gender.filter((gg) => gender === gg.gender)[0].code;
      let ms = await MaritalValue.filter((ms) => maritalStatus === ms.status)[0]
        .code;

      const body = {
        tc,
        accountType,
        lastName,
        firstName,
        middleName,
        address,
        address2: address,
        religion,
        ms,
        gn,
        phone,
        dob,
        email,
        bvn,
        state,
        lga,
        country,
        altPhone,
        altEmail,
        currentAddress,
        branch,
        rmCode,
        fieldToUpdate,
        new_cust_id,
      };
      try {
        topRef.current.scrollIntoView({ behavior: "smooth" });
      } catch (er) {}
      if (!agreementCheckBox) {
        setError(" Kindly check terms & conditions to proceed");
        setSubmitting(false);
        loading(false);
        return;
      } else if (accountType == "" && canUpdateField("acct_type")) {
        setValidationErrors({ accountType: " Account Type is required" });
        setError("Account Type is required");
        setSubmitting(false);
        loading(false);
        return;
      } else if (religion == "" && canUpdateField("religion")) {
        setValidationErrors({ religion: " Religion is required" });
        setError("Religion Type is required");
        setSubmitting(false);
        loading(false);
        return;
      } else if (country == "" && canUpdateField("country")) {
        setValidationErrors({ country: " Country of Residence is required" });
        setError("Country of Residence is required");
        setSubmitting(false);
        loading(false);
        return;
      } else if (branch == "" && canUpdateField("braCode")) {
        setValidationErrors({ branch: " Branch is required" });
        setError("Branch is required");
        setSubmitting(false);
        loading(false);
        return;
      } else if (trimStr(currentAddress) == "" && canUpdateField("address")) {
        setValidationErrors({ currentAddress: " Current Address is required" });
        setError("Current Address is required");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        trimStr(altEmail) != "" &&
        !ValidateEmail(trimStr(altEmail)) &&
        canUpdateField("altEmail")
      ) {
        setValidationErrors({ altEmail: " Alternative email is invalid" });
        setError("Alternative email is invalid");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        (passportInfo == null || passportInfo.status == "removed") &&
        canUpdateField("passport")
      ) {
        setValidationErrors({ passport: "Kindly upload a valid passport" });
        setError("Kindly upload a valid passport");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        (identityInfo == null || identityInfo.status == "removed") &&
        canUpdateField("identity")
      ) {
        setValidationErrors({
          identity: "Kindly upload a valid Means of Identification ",
        });
        setError("Kindly upload a valid Means of Identification");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        (utilityInfo == null || utilityInfo.status == "removed") &&
        canUpdateField("utility")
      ) {
        setValidationErrors({
          utility: "Kindly upload a valid Utility Bill ",
        });
        setError("Kindly upload a valid Utility Bill ");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        (signatureInfo == null || signatureInfo.status == "removed") &&
        canUpdateField("signature")
      ) {
        setValidationErrors({
          signature: "Kindly upload a valid Signature ",
        });
        setError("Kindly upload a valid Signature");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        (referenceInfo == null || referenceInfo.status == "removed") &&
        canUpdateField("reference")
      ) {
        setValidationErrors({
          reference: "Kindly upload a valid Reference ",
        });
        setError("Kindly upload a valid Reference");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        passportInfo != null &&
        passportInfo.status == "error_file_size" &&
        canUpdateField("passport")
      ) {
        setValidationErrors({
          passport: "Image size cannot be greater than 5MB",
        });
        setError("Image size cannot be greater than 5MB");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        passportInfo != null &&
        passportInfo.status !== "done" &&
        canUpdateField("passport")
      ) {
        setValidationErrors({ passport: "Image not properly uploaded" });
        setError("Image not properly uploaded");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        identityInfo != null &&
        identityInfo.status == "error_file_size" &&
        canUpdateField("identity")
      ) {
        setValidationErrors({
          identity: "Identity file size cannot be greater than 5MB",
        });
        setError("Identity file size cannot be greater than 5MB");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        identityInfo != null &&
        identityInfo.status !== "done" &&
        canUpdateField("identity")
      ) {
        setValidationErrors({
          identity: "Identity file not properly uploaded",
        });
        setError("Identity file not properly uploaded");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        utilityInfo != null &&
        utilityInfo.status == "error_file_size" &&
        canUpdateField("utility")
      ) {
        setValidationErrors({
          utility: "Utility file size cannot be greater than 5MB",
        });
        setError("Utility file size cannot be greater than 5MB");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        utilityInfo != null &&
        utilityInfo.status !== "done" &&
        canUpdateField("utility")
      ) {
        setValidationErrors({ utility: "Utility file not properly uploaded" });
        setError("Utility file not properly uploaded");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        signatureInfo != null &&
        signatureInfo.status == "error_file_size" &&
        canUpdateField("signature")
      ) {
        setValidationErrors({
          signature: "Signature file size cannot be greater than 5MB",
        });
        setError("Signature file size cannot be greater than 5MB");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        signatureInfo != null &&
        signatureInfo.status !== "done" &&
        canUpdateField("signature")
      ) {
        setValidationErrors({
          signature: "Signature file not properly uploaded",
        });
        setError("Signature file not properly uploaded");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        referenceInfo != null &&
        referenceInfo.status == "error_file_size" &&
        canUpdateField("reference")
      ) {
        setValidationErrors({
          reference: "Reference file size cannot be greater than 5MB",
        });
        setError("Reference file size cannot be greater than 5MB");
        setSubmitting(false);
        loading(false);
        return;
      } else if (
        referenceInfo != null &&
        referenceInfo.status !== "done" &&
        canUpdateField("reference")
      ) {
        setValidationErrors({
          reference: "Reference file not properly uploaded",
        });
        setError("Reference file not properly uploaded");
        setSubmitting(false);
        loading(false);
        return;
      }

      const formData = new FormData();

      if (passportInfo != null && canUpdateField("passport")) {
        formData.append(
          "passport",
          passportInfo.file,
          passportInfo.file.name +
            "---__" +
            trimStr(firstName) +
            "_" +
            trimStr(middleName) +
            "_" +
            trimStr(lastName)
        );
      }
      if (utilityInfo != null && canUpdateField("utility")) {
        formData.append(
          "utility",
          utilityInfo.file,
          utilityInfo.file.name +
            "---__" +
            trimStr(firstName) +
            "_" +
            trimStr(middleName) +
            "_" +
            trimStr(lastName)
        );
      }
      if (identityInfo != null && canUpdateField("identity")) {
        formData.append(
          "identity",
          identityInfo.file,
          identityInfo.file.name +
            "---__" +
            trimStr(firstName) +
            "_" +
            trimStr(middleName) +
            "_" +
            trimStr(lastName)
        );
      }
      if (signatureInfo != null && canUpdateField("signature")) {
        formData.append(
          "signature",
          signatureInfo.file,
          signatureInfo.file.name +
            "---__" +
            trimStr(firstName) +
            "_" +
            trimStr(middleName) +
            "_" +
            trimStr(lastName)
        );
      }
      if (referenceInfo != null && canUpdateField("reference")) {
        formData.append(
          "reference",
          referenceInfo.file,
          referenceInfo.file.name +
            "---__" +
            trimStr(firstName) +
            "_" +
            trimStr(middleName) +
            "_" +
            trimStr(lastName)
        );
      }

      formData.append("data", JSON.stringify(body));
      const response = await axios.post(
        "https://providusonline.providusbank.com:8443/apitest/account/ops/update_individual_account_api",
        formData,
        { timeout: 180000 }
      );

      if (response.data.status) {
        setSubmitting(false);
        loading(false);

        
        go("successUpdate");
      } else {
        setSubmitting(false);
        loading(false);
        setError(response.data.ResponseDetInfo);
      }
    } catch (error) {
      setSubmitting(false);
      loading(false);
      try {
        setValidationErrors(error.response.data);
      } catch (er) {
        setValidationErrors({
          error: error.message,
        });
      }
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <>
        <ProgressBar page="basicInfo" />
        <Fade bottom>
          <form id="msform">
            <fieldset>
              <h2 className="fs-title" ref={topRef}>
                BASIC INFORMATION
              </h2>
              <h3 className="fs-subtitle text-danger">
                {fieldToUpdate != "" && fieldToUpdate != null
                  ? "Continue/Update existing record"
                  : "Approval pending on recently created account "}
              </h3>
              <br />
              <h3 className="fs-subtitle text-danger">
                Fields marked with <sup>*</sup> are mandatory
              </h3>

              <p className="text-danger">
                {error != null && error != "" ? error : validationError.error}
              </p>
              <hr />

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={accountType != "" ? "" : "text-danger"}
                      htmlFor="exampleFormControlSelect1"
                    >
                      Account Type <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect1"
                      name="accountType"
                      defaultValue={accountType}
                      disabled={!canUpdateField("acct_type")}
                      onChange={(e) => setAccountType(e.currentTarget.value)}
                      required
                    >
                      <option>Select Account Type</option>
                      <option value="184" selected={accountType == "184" ? true : false}>Regal Savings</option>
                      <option value="52" selected={accountType == "52" ? true : false}>Regal Current</option> 
                      <option
                        value="65"
                        selected={accountType == "65" ? true : false}
                      >
                        Savings
                      </option>
                      <option
                        value="40"
                        selected={accountType == "40" ? true : false}
                      >
                        Current
                      </option>
                    </select>
                    <p className="text-danger">{validationError.accountType}</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={religion != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Religion <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect2"
                      name="religion"
                      defaultValue={religion}
                      disabled={!canUpdateField("religion")}
                      onChange={(e) => setReligion(e.currentTarget.value)}
                      required
                    >
                      <option>Select your Religion</option>
                      <option
                        value="1"
                        selected={religion == "1" ? true : false}
                      >
                        Christianity
                      </option>
                      <option
                        value="2"
                        selected={religion == "2" ? true : false}
                      >
                        Islam
                      </option>
                      <option
                        value="4"
                        selected={religion == "4" ? true : false}
                      >
                        Hindu
                      </option>
                      <option
                        value="3"
                        selected={religion == "3" ? true : false}
                      >
                        Others
                      </option>
                    </select>
                    <p className="text-danger">{validationError.religion}</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label
                      className={country != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Country of Residence <sup className="text-danger">*</sup>
                    </label>
                    <ReactSelect
                      value={{ label: country, value: country }}
                      disabled={!canUpdateField("country")}
                      onChange={
                        (e) => {
                          setCountry(e.value);
                        }
                        // setCountry(e.currentTarget.value)
                      }
                      options={Countries}
                    />
                    {/* <select
                      className="form-control select2"
                      id="exampleFormControlSelect3"
                      name="country"
                      defaultValue={country}
                      disabled={!canUpdateField("country")}
                      onChange={(e) => setCountry(e.currentTarget.value)}
                      required
                    >
                      <option>Select a Country</option>

                      {Countries.map((row, index) => (
                        <option value={row} key={index}>
                          {row}
                        </option>
                      ))}
                    </select> */}
                    <p className="text-danger">{validationError.country}</p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <select
                      className="form-control"
                      id="title"
                      name="title"
                      disabled
                    >
                      <option value={title}>{title}</option>
                      <option>MR</option>
                      <option>Miss</option>
                      <option>MRS</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Date of Birth</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Date of Birth"
                      name="dob"
                      value={mask(dob)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Gender</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      disabled
                    >
                      <option value={gender}>{gender}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="First Name"
                      name="firstname"
                      value={mask(firstName)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Middle Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Middle Name"
                      name="middlename"
                      value={mask(middleName)}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Last Name"
                      name="lastname"
                      value={mask(lastName)}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1"> Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Phone Number"
                      name="phone"
                      value={mask(phone)}
                      disabled
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Email"
                      name="email"
                      value={longMask(email)}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Alternative Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Alternative Phone Number"
                      name="altPhone"
                      disabled={!canUpdateField("altPhone")}
                      value={altPhone}
                      onChange={(e) => setAltPhone(e.currentTarget.value)}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      {" "}
                      Alternative Email
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Alternative Email"
                      name="altEmail"
                      value={altEmail}
                      disabled={!canUpdateField("altEmail")}
                      onChange={(e) => setAltEmail(e.currentTarget.value)}
                    />
                    <p className="text-danger">{validationError.altEmail}</p>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">State of Origin</label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="state"
                      disabled
                    >
                      <option value={state}>{state}</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">
                      Local Government Area
                    </label>
                    <select
                      className="form-control"
                      id="exampleFormControlSelect1"
                      name="LGA"
                      disabled
                    >
                      <option value={lga}>{lga}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label
                      className={branch != "" ? "" : "text-danger"}
                      htmlFor="exampleInputEmail1"
                    >
                      Branch <sup className="text-danger">*</sup>
                    </label>
                    <select
                      className="form-control select2"
                      id="exampleFormControlSelect3"
                      name="branch"
                      onChange={(e) => setBranch(e.currentTarget.value)}
                      required
                      disabled={!canUpdateField("braCode")}
                    >
                      <option value="">Select a Branch</option>
                      {allBranch.map((row, index) => {
                        return (
                          <option
                            value={row.code}
                            selected={branch == row.code ? true : false}
                            key={index}
                          >
                            {row.name}
                          </option>
                        );
                      })}

                      {/* // <option value="202">Head Office (Victoria Island)</option>
                      // <option value="203">Victoria Island</option>
                      // <option value="204">Abuja Main</option>
                      // <option value="205">Festac</option>
                      // <option value="206">Gbagada</option>
                      // <option value="207">Ikota</option>
                      // <option value="209">Ikeja</option>
                      // <option value="210">Apapa</option>
                      // <option value="211">Akure</option>
                      // <option value="212">Nnamdi Azikwe</option>
                      // <option value="213">Lekki</option> */}
                    </select>
                    <p className="text-danger">{validationError.branch}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">RM Code</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="RM Code/Name"
                      name="rmCode"
                      value={rmCode}
                      disabled={!canUpdateField("rmCode")}
                      onChange={(e) => setRmCode(e.currentTarget.value)}
                    />
                  </div>
                </div>
              </div>

              {/* <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="exampleFormControlTextarea1">
                        Contact Address
                      </label>
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        name="address"
                        value={longMask(address)}
                        placeholder="Please type your full address"
                        disabled
                      ></textarea>
                    </div>
                  </div>
                </div> */}

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label
                      htmlFor="exampleFormControlTextarea1"
                      className={
                        trimStr(currentAddress) != "" ? "" : "text-danger"
                      }
                    >
                      Current Address <sup className="text-danger">*</sup>
                    </label>
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      name="currentAddress"
                      value={currentAddress}
                      placeholder="Please type your full address"
                      onChange={(e) => setCurrentAddress(e.currentTarget.value)}
                      disabled={!canUpdateField("address")}
                    ></textarea>
                    <p className="text-danger">
                      {validationError.currentAddress}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                {canUpdateField("utility") ? (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className={
                          utilityInfoStatus == "done" ||
                          !canUpdateField("utility")
                            ? ""
                            : "text-danger"
                        }
                      >
                        Utility Bill (PDF,JPEG, JPG, PNG)
                        <sup className="text-danger">*</sup>
                      </label>
                      <FileUploadComponent
                        setFileInfo={setUtilityInfo}
                        path={utilityPath}
                        disabled={!canUpdateField("utility")}
                        fineInfo={utilityInfo}
                        type="Utility"
                        // setValidationErrors={setValidationErrors}
                      />
                      <p className="text-danger">{validationError.utility}</p>
                    </div>
                  </div>
                ) : null}
                {canUpdateField("signature") ? (
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className={
                          signatureInfoStatus == "done" ||
                          !canUpdateField("signature")
                            ? ""
                            : "text-danger"
                        }
                      >
                        Signature (PDF,JPEG, JPG, PNG)
                        <sup className="text-danger">*</sup>
                      </label>
                      <FileUploadComponent
                        setFileInfo={setSignatureInfo}
                        fineInfo={signatureInfo}
                        path={signaturePath}
                        disabled={!canUpdateField("signature")}
                        type="Signature"
                        // setValidationErrors={setValidationErrors}
                      />
                      {/* <Camera size={30}/> */}
                      <p className="text-danger">{validationError.signature}</p>
                    </div>
                  </div>
                ) : null}
           
                {canUpdateField("passport") ? (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className={
                          passportInfoStatus == "done" ||
                          !canUpdateField("passport")
                            ? ""
                            : "text-danger"
                        }
                      >
                        Passport Photo (JPEG, JPG, PNG)
                        <sup className="text-danger">*</sup>
                      </label>
                      <FileUploadComponent
                        setFileInfo={setPassportInfo}
                        fineInfo={passportInfo}
                        path={passportPath}
                        type="Passport"
                        disabled={!canUpdateField("passport")}
                        // setValidationErrors={setValidationErrors}
                      />
                      {/* <Camera /> */}
                      <p className="text-danger">{validationError.passport}</p>
                    </div>
                  </div>
                ) : null}
                {canUpdateField("identity") ? (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className={
                          identityInfoStatus == "done" ||
                          !canUpdateField("identity")
                            ? ""
                            : "text-danger"
                        }
                      >
                        Means of Identification (PDF,JPEG, JPG, PNG)
                        <sup className="text-danger">*</sup>
                      </label>
                      <FileUploadComponent
                        setFileInfo={setIdentityInfo}
                        fineInfo={identityInfo}
                        path={identityPath}
                        disabled={!canUpdateField("identity")}
                        type="Identification"
                        // setValidationErrors={setValidationErrors}
                      />
                      <p className="text-danger">{validationError.identity}</p>
                    </div>
                  </div>
                ) : null}
                {canUpdateField("reference") ? (
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className={
                          referenceInfoStatus == "done" ||
                          !canUpdateField("reference")
                            ? ""
                            : "text-danger"
                        }
                      >
                        Reference (PDF,JPEG, JPG, PNG)
                        <sup className="text-danger">*</sup>
                      </label>
                      <FileUploadComponent
                        setFileInfo={setReferenceInfo}
                        fineInfo={referenceInfo}
                        path={referencePath}
                        disabled={!canUpdateField("reference")}
                        type="Reference"
                        // setValidationErrors={setValidationErrors}
                      />
                      <p className="text-danger">{validationError.reference}</p>
                    </div>
                  </div>
                ) : null}
              </div>

              <p>
                <input
                  style={{ marginRight: "5px" }}
                  type="checkbox"
                  required={true}
                  checked={agreementCheckBox}
                  onChange={() => setAgreementCheckBox(!agreementCheckBox)}
                />
                I Agree to the
                <a
                  href="#"
                  onClick={() => setShowTerm(true)}
                  style={{ color: "#efb331" }}
                >
                  {" "}
                  Terms & Conditions
                </a>
              </p>

              {!submitting ? (
                <>
                  <input
                    type="button"
                    name="previous"
                    className="previous action-button"
                    value="Previous"
                    onClick={() => go("bvn")}
                  />

                  <input
                    type="button"
                    name="submit"
                    className={
                      allDataValid ? "next action-button" : " disabled-button"
                    }
                    value="Submit"
                    // onClick={onSubmit}
                    disabled={!allDataValid}
                    onClick={onSubmit}
                    // onClick={() => setShowTerm(true)}
                  />
                </>
              ) : (
                <input
                  type="button"
                  name="submit"
                  className="btn next action-button"
                  value="Processing..."
                  disabled
                />
              )}

              <div
                className="d-flex align-items-center"
                ref={bottomRef}
                // ref={(el) => {
                //   bottomRef = el;
                // }}
              >
                <p className="text-danger align-self-center">
                  {error != null && error != "" ? error : validationError.error}
                </p>
              </div>
              <label>
                   <b> <a href="https://oap.providusbank.com/providus_files/reference-form.pdf" target="_blank" style={{textDecoration:"none",color:"#efb331"}}> Download Reference    <img
                        className="mr-2"
                        src={PDFIcon}
                        alt="reference"
                        width="25"
                      /></a></b>
                  </label>
            </fieldset>
          </form>
          <br />
        </Fade>
      </>

      <Terms showTerm={showTerm} handleClose={handleClose} />
      <Selfie
        showSelfie={showSelfie}
        handleClose={handleCloseSelfie}
        SubmitSelfie={SubmitSelfie}
      />
    </div>
  );
};

export default BasicInformation;
